<span [matTooltip]="canCreateDatastory ? '' : 'Add datasets to the workspace and start creating compelling Stories with your data'"
    matTooltipPosition="below"
    matTooltipClass="mat-tooltip--below">
    <button class="btn btn--secondary btn--dku-icon" 
        [disabled]="!canCreateDatastory" 
        (click)="openCreateDatastoryModal()" >
        <i class="dku-icon-plus-16"></i>Create story
    </button>
</span>
